import { IconDownload, IconLoader, Popup, InputText } from '@ui/src';
import { IndividualApplicationStepThreeDocumentsTypes } from '../types';
import StepPartBlock from '../../../common/step-part-block';
import DocumentsItems from './parts/documents-items';
import useDocuments from '../../hooks/use-documents';

import cn from '../../styles.module.css';

const StepDocuments = ({
  documents,
  selectedDocumentsCounts,
  onGroupSelect,
  applicationId,
  cof,
  setSelected,
  search,
  status,
  renameAvailable,
}: IndividualApplicationStepThreeDocumentsTypes) => {
  const {
    setSelectedDocument,
    setRenamePopupVisible,
    isLoading,
    cofDocIsLoading,
    getFiles,
    setDocumentName,
    setNameError,
    onRename,
    renameInProgress,
    renameCofDocumentInProgress,
    renamePopupVisible,
    selectedDocument,
    documentName,
    nameError,
    errors,
  } = useDocuments({
    cof,
    applicationId,
    documents,
    onGroupSelect,
  });

  let documentsContent;

  if (documents && !documents?.length) {
    documentsContent = (
      <div className={cn.emptyDocuments}>No attached documents yet</div>
    );
  } else if (documents && documents.length > 0) {
    documentsContent = (
      <DocumentsItems
        onGroupSelect={onGroupSelect}
        documents={documents}
        applicationId={applicationId}
        setSelected={setSelected}
        cof={cof}
        search={search}
        setSelectedDocument={setSelectedDocument}
        setRenamePopupVisible={setRenamePopupVisible}
        status={status}
        renameAvailable={renameAvailable}
      />
    );
  }

  return (
    <>
      <StepPartBlock title="Confirming documents" zIndex={10}>
        <div className={cn.documentsTop}>
          <div className={cn.documentsTopLeft}>
            <button
              type="button"
              className={cn.selectedDocumentsButton}
              disabled={
                selectedDocumentsCounts === 0 || isLoading || cofDocIsLoading
              }
              onClick={getFiles}
              tabIndex={-1}
            >
              {isLoading || cofDocIsLoading ? (
                <IconLoader
                  className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                  width={16}
                  height={16}
                />
              ) : (
                <IconDownload
                  className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
                  width={16}
                  height={16}
                />
              )}

              {isLoading || cofDocIsLoading ? 'Loading...' : 'Download'}
            </button>
          </div>
        </div>
        {documentsContent}
      </StepPartBlock>

      <Popup
        title="Rename"
        onCancelClick={() => {
          setRenamePopupVisible(false);
          setSelectedDocument(undefined);
          setDocumentName('');
          setNameError('');
        }}
        onOkClick={onRename}
        cancelButtonText="Cancel"
        okButtonText={
          renameInProgress || renameCofDocumentInProgress
            ? 'Loading...'
            : 'Rename'
        }
        isVisible={renamePopupVisible}
        okButtonDisabled={selectedDocument?.name === documentName}
      >
        <InputText
          name="documentName"
          value={documentName}
          onChange={(e) => setDocumentName(e.target.value)}
          placeholder="Enter document name"
          labelClassName={cn.renameInput}
          error={nameError || (errors?.name?.message as string)}
        />
      </Popup>
    </>
  );
};

export default StepDocuments;
